<template>
  <div class="player-container">
    <div class="top-service-bar">
      <img src="@/assets/logo.png" alt="" class="img" />
      <!-- 根据登录状态显示不同内容 -->
      <div v-if="isLoggedIn" class="user-info">
        <span class="welcome-text">欢迎，{{ userName }}</span>
        <el-button type="text" @click="handleLogout" class="logout-btn">退出</el-button>
      </div>
      <div v-else>
        <el-button icon="el-icon-user-solid" class="button" @click="showLoginDialog = true">登录</el-button>
      </div>
    </div>
    
    <!-- 播放器容器 -->
    <div v-if="isLoggedIn && videoType == 2" class="videobox">
      <div class="player-wrapper">
        <div id="player" class="player-inner" ref="playerContainer"></div>
      </div>
      <div class="videoinfo" v-if="videoInfo">
        <div class="info-right">
          <div class="title-container">
            <span class="title">{{ videoInfo.name }}</span>
            <span class="status">回放中</span>
          </div>
          <div class="teacher">讲师: {{ videoInfo.teacherName || '暂无' }}</div>
        </div>
      </div>
    </div>
    
    <iframe :src="videoUrl" frameborder="0" style="width: 100%; flex: 1; height: calc(100vh - 70px);" v-if="videoType == 1 && isLoggedIn"
      allowfullscreen="true"></iframe>

    <!-- 错误状态 -->
    <div v-if="error" class="error-overlay">
      <div class="error-content">
        <i class="el-icon-warning"></i>
        <p>{{ error }}</p>
        <el-button @click="retry">重试</el-button>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <LoginDialog v-model="showLoginDialog" @login-success="handleLoginSuccess" />
  </div>
</template>

<script>
import { getVideoPlayerInfo, getWatchUrl, logout, getUserProfile } from "@/api/index.js";

export default {
  name: "VideoPlayer",
  data() {
    return {
      loading: true,
      error: null,
      videoId: null,
      channelId: null,
      videoType: null, // 1-直播，2-录播
      videoInfo: null, // 视频详细信息
      classId: null, // 班级ID
      vid: null, // 视频VID
      isPublicCourse: false, // 是否为公开课
      vodPlayerJs: "https://player.polyv.net/resp/vod-player/latest/player.js",
      videoUrl: null,
      showLoginDialog: false, // 登录弹窗
      player: null,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    userName() {
      const userInfo = this.$store.getters.userInfo;
      return userInfo.name || userInfo.username || "用户";
    },
  },
  mounted() {
    this.videoId = this.$route.query.videoId;
    this.classId = this.$route.query.classId;
    this.isPublicCourse = this.$route.query.isPublicCourse === "true";
    this.videoType = parseInt(this.$route.query.videotype) || 2;
    
    if (!this.isLoggedIn) {
      this.showLoginDialog = true;
      return;
    }
    this.initPlayer();
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
  methods: {
    initPlayer() {
      if (this.videoType == 1) {
        this.getVideoUrl();
      } else {
        this.initVodPlayer();
      }
    },
    handleLoginSuccess(loginInfo) {
      this.$store.dispatch("login", {
        token: loginInfo.token,
        refreshToken: loginInfo.refreshToken,
        userType: loginInfo.userType,
        userId: loginInfo.userId,
        tenantId: loginInfo.tenantId,
        userInfo: {},
      });
      this.fetchUserInfo();
      this.showLoginDialog = false;
      this.$message.success("登录成功，欢迎回来！");
      this.initPlayer();
    },
    getVideoUrl() {
      getWatchUrl({ videoId: this.videoId }).then((res) => {
        this.videoUrl = res.data.watchUrl;
      }).catch(err => {
        this.error = "获取直播地址失败";
      });
    },
    async initVodPlayer() {
      try {
        this.error = null;
        const response = await getVideoPlayerInfo(this.videoId);
        if (response.code === 0 && response.data) {
          this.videoInfo = response.data;
          this.vid = response.data.vid;
          if (!this.vid) {
            throw new Error("视频未配置VID");
          }
        } else {
          throw new Error(response.msg || "获取视频信息失败");
        }
        
        if (!window.polyvPlayer) {
          const myScript = document.createElement("script");
          myScript.setAttribute("src", this.vodPlayerJs);
          myScript.onload = () => { this.mountPolyvPlayer(); };
          myScript.onerror = () => {
            this.error = "播放器脚本加载失败，请稍后重试";
          };
          document.body.appendChild(myScript);
        } else {
          this.mountPolyvPlayer();
        }
      } catch (error) {
        console.error("加载录播失败:", error);
        this.error = error.message || "加载录播失败";
      }
    },
    mountPolyvPlayer() {
      if (!window.polyvPlayer) return;
      
      const userInfo = this.$store.getters.userInfo || {};
      let viewerInfo = {
        viewerId: userInfo.id || '',
        viewerName: userInfo.name || '',
        viewerAvatar: userInfo.avatar || '',
        viewerExtraInfo1: userInfo.username || '',
        viewerExtraInfo2: userInfo.mobile || '',
      };

      this.$nextTick(() => {
        if (!document.getElementById("player")) {
          console.error("播放器容器 #player 不存在");
          return;
        }
        this.player = window.polyvPlayer({
          wrap: "#player",
          width: "100%",
          height: "100%",
          vid: this.vid,
          playsafe: '', // 如果有 token 可以传，没有置空
          showHd: true,
          show_rate: 2,
          df: 3,
          showLine: "on",
          viewerInfo: viewerInfo
        });
      });
    },
    destroyPlayer() {
      if (this.player && typeof this.player.destroy === 'function') {
        try {
          this.player.destroy();
        } catch (e) {
          console.error("销毁失败", e);
        }
        this.player = null;
      }
    },
    retry() {
      this.error = null;
      this.destroyPlayer();
      this.initPlayer();
    },
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        type: "warning",
      }).then(() => {
        logout().finally(() => {
          this.$store.commit("clearLoginState");
          this.$message.success("已退出登录");
          this.showLoginDialog = true; // 退出后可选择重新显示登录框
        });
      }).catch(err => {
        if (err !== 'cancel') {
          console.error("退出登录出错:", err);
        }
      });
    },
    fetchUserInfo() {
      if (!this.isLoggedIn) return;
      getUserProfile().then((res) => {
        if (res.data) {
          this.$store.dispatch("updateUserInfo", res.data);
        }
      }).catch(() => {
        this.$store.commit("clearLoginState");
      });
    },
  },
};
</script>

<style scoped lang="scss">
.player-container {
  min-height: 100vh;
  background-color: #131519;
  display: flex;
  flex-direction: column;

  .top-service-bar {
    width: 100%;
    padding: 15px 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #131519;

    .img {
      height: 40px;
    }

    .user-info {
      display: flex;
      align-items: center;
      color: #fff;

      .welcome-text {
        margin-right: 15px;
      }
      
      .logout-btn {
        color: #909399;
        &:hover {
          color: #fff;
        }
      }
    }
  }

  .videobox {
    flex: 1;
    width: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;

    .player-wrapper {
      width: 100%;
      height: calc(100vh - 160px);
      background: #000;

      .player-inner {
        width: 100%;
        height: 100%;
      }
    }

    .videoinfo {
      width: 100%;
      background: #1c1e22;
      padding: 20px 40px;
      box-sizing: border-box;

      .info-right {
        display: flex;
        align-items: center;

        .title-container {
          color: #fff;
          font-size: 18px;
          margin-right: 12px;
          display: flex;
          align-items: center;
        }

        .status {
          background-color: rgba(103, 194, 58, 0.1);
          color: #67c23a;
          font-size: 12px;
          padding: 2px 6px;
          border-radius: 4px;
          margin-left: 10px;
        }

        .teacher {
          color: #909399;
          margin-left: 20px;
          font-size: 14px;
        }
      }
    }
  }

  .error-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: #fff;

    .error-content {
      text-align: center;
      background: #2b2f36;
      padding: 40px 60px;
      border-radius: 8px;

      i {
        font-size: 48px;
        color: #f56c6c;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        margin-bottom: 30px;
      }
    }
  }
}

@media (max-width: 992px) {
  .player-container {
    .top-service-bar {
      padding: 15px 20px;
    }

    .videobox {
      .player-wrapper {
        min-height: 56vw;
      }

      .videoinfo {
        padding: 15px 20px;
        flex-direction: column;
        align-items: flex-start;

        .info-right {
          flex-direction: column;
          align-items: flex-start;

          .teacher {
            margin-left: 0;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>